import { withPrefix as gatsbyWithPrefix } from 'gatsby'

const PATH_PREFIX = '/docs'
const pathRegex = new RegExp(`^${PATH_PREFIX}`)

export function hasPrefix(path) {
	return pathRegex.test(path)
}

export function withPrefix(path) {
	return hasPrefix(path) ? path : gatsbyWithPrefix(path)
}

export function withoutPrefix(path) {
	return path?.replace(pathRegex, '')
}

export function isRootPath(path) {
	return normalisePath(path) === ''
}

export function normalisePath(path) {
	return withoutPrefix(path?.replace(/\/$/, ''))
}
